import { locItem } from '../../../model/game';
import { loc } from '../common';

export default loc(
  3, 'Runestone_Swamps', ['Swamp'],
  { type: 'runestone', quantity: 100, group: 'Runestones', minApart: 128, minAlt: 0, radius: [20, 8],
    items: [locItem('RuneStone_Swamps')] }
);
